import StoredLayout from '../../layouts/StoredLayout'
import SimpleLineIcons from './SimpleLineIcons'
export default StoredLayout(SimpleLineIcons)



// WEBPACK FOOTER //
// ./src/icons/simple-line-icons/index.js